<template>
  <router-link
  :to="'/service/'+id"
    class="h-48 max-w-sm w-full lg:max-w-full lg:flex shadow-lg bg-white cursor-pointer hover:bg-gray-200 hover:shadow-xl rounded"
  >
    <div
      class="h-48 lg:h-auto lg:w-48 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden"
      :style="{backgroundImage: 'url(\''+imageUrl+'\')'}"
      title="Woman holding a mug"
    ></div>
    <div
      class="w-full rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal bg-white hover:bg-gray-200 shadow sm:shadow-none"
    >
      <div class="mb-1">
        <div
          class="text-gray-900 font-bold text-xl mb-2 max-h-7 overflow-hidden"
        >{{title}}</div>
        <p class="text-gray-700 text-base max-h-15 overflow-hidden leading-5">{{description}}</p>
      </div>
      <div class="flex justify-between items-end">
        <div>
          <div class="flex items-center">
            <IconSvg :solid="true" icon="location-marker" class="h-5 w-5 text-primary-500"/>
            <div class="text-sm ml-1">
              <p class="text-gray-900 leading-none">{{address}}</p>
            </div>
          </div>
          <div class="flex items-center mt-1">
            <IconSvg :solid="true" icon="star" class="h-5 w-5 text-yellow-400"/>
            <div class="text-sm ml-1">
              <p class="text-gray-900 leading-none">{{supplier_rating}}</p>
            </div>
          </div>
        </div>
        <p class="text-gray-900 text-sm font-bold leading-none">S/ {{min_price}} a S/ {{max_price}}</p>
      </div>
    </div>
  </router-link>
</template>
<script>
import IconSvg from "./IconSvg.vue";

export default {
  name: "ServiceCard",
  components: {
    IconSvg
  },
  props: {
    id: String,
    imageUrl: String,
    title: String,
    description: String,
    address: String,
    supplier_rating: String,
    min_price: String,
    max_price: String,
  }
};
</script>